import { createFileRoute } from '@tanstack/react-router'
import EmployeeDashboard from '@/features/employee-portal/pages/EmployeeDashboard'

export const Route = createFileRoute('/_authenticated/employee-portal/')({
  component: EmployeeDashboard,
})